// ── Feature flags ─────────────────────────────────────────────────────────────
// Set to true to re-enable a feature across the entire app.

export const WISHLIST_ENABLED = false;
export const IMAGE_ZOOM_ENABLED = false;
export const HEADER_ACTIONS_HIDDEN = process.env.REACT_APP_HIDE_HEADER_ACTIONS === 'true';
